import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRemoteUICopy } from '../copy.js';
export function CompactionItem({ item }) {
    const copy = useRemoteUICopy();
    return _jsxs("article", { className: "agent-timeline-item agent-compaction", "aria-label": copy.contextCompaction, children: [_jsx("strong", { children: copy.contextCompaction }), _jsx("span", { children: copy.status(item.status === 'loading' ? 'in_progress' : 'completed') }), item.trigger ? _jsx("span", { children: copy.compactionTrigger(item.trigger) }) : null] });
}
//# sourceMappingURL=CompactionItem.js.map